import { render, staticRenderFns } from "./HealthBad.vue?vue&type=template&id=de5c6b2a&"
import script from "./HealthBad.vue?vue&type=script&lang=js&"
export * from "./HealthBad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de5c6b2a')) {
      api.createRecord('de5c6b2a', component.options)
    } else {
      api.reload('de5c6b2a', component.options)
    }
    module.hot.accept("./HealthBad.vue?vue&type=template&id=de5c6b2a&", function () {
      api.rerender('de5c6b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/HealthBad.vue"
export default component.exports